import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngAnimate from 'angular-animate';
import ngFileUpload from 'ng-file-upload';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import 'normalize.css';

import 'font-awesome/css/font-awesome.css';
require('angular-drag-and-drop-lists');

angular.module('app', [
    uiRouter,
    ngAnimate,
    Common,
    Components,
    ngFileUpload,
    require('angular-ladda'),
    require('angular-sanitize'),
    require('textangular'),
    'dndLists'
  ])
    .run(['$state','AuthorisationService', '$transitions', '$rootScope',
        function($state, AuthorisationService, $transitions, $rootScope)
        {
            // *** handle security ***
            // run this for any routes under app parent
            $transitions.onBefore({ to: ['app.*', 'app.*.*', 'app.*.*.*', 'app.*.*.*.*'] }, function($transition$) {

                document.getElementsByTagName('body')[0].classList.remove("body-gray");

                // check if logged in
                if(AuthorisationService.isAuthenticated()){

                    // check if authorised to view this route
                    return AuthorisationService.authorise($transition$.to().data.roles).catch(function(){

                        // not authorised, redirect
                        return $state.target('app.forbidden');

                    });

                }
                else{
                    // not logged in, redirect
                    return $state.target('login');
                }
            });


            // When already logged in and we go to login page redirect to racedays.
            $transitions.onBefore({ to: 'login' }, function($transition$) {

                document.getElementsByTagName('body')[0].className += ' body-gray';

                // check if logged in
                if(AuthorisationService.isAuthenticated()){

                    // logged in OK so redirect
                    return $state.target('app.racedays');
                }

            });
        }
    ])
    .config(['$locationProvider', '$stateProvider', '$urlRouterProvider',function($locationProvider, $stateProvider, $urlRouterProvider){
        "ngInject";
        // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
        // #how-to-configure-your-server-to-work-with-html5mode
        //$locationProvider.html5Mode(true).hashPrefix('!');
        $urlRouterProvider.otherwise('/');
        $stateProvider
          .state('app', {
              'abstract': true,
              resolve: {
                  user: ['AuthorisationService',
                      function(AuthorisationService) {
                          return AuthorisationService.getUser();
                      }
                  ]
              },
              template: '<Navbar></Navbar><div class="content" ui-view="primary"></div><footer></footer>'
          })
          .state('login', {
              url: '/',
              component: 'loginPage'
          })
          .state('app.forbidden', {
              url: '/forbidden',
              data: {
                  roles: ['*','ROLE_USER']
              },
              views: {
                  'primary@app': {
                      component: 'forbiddenPage'
                  }
              }
          })
          .state('app.racedays', {
              url: '/racedays',
              data: {
                  roles: ['ROLE_USER']
              },
              views: {
                  'primary@app': {
                      component: 'racedaysPage'
                  }
              }
          })
            .state('app.racedays.add', {
                url: '/add',
                data: {
                    roles: ['ROLE_USER']
                },
                views: {
                    'primary@app': {
                        component: 'racedaysAddPage'
                    }
                }
            })
            .state('app.racedays.raceday', {
            url: '/:id',
            resolve: {
                raceday: ['$stateParams', 'RacedaysService',
                    function($stateParams, RacedaysService) {
                        return RacedaysService.getById($stateParams.id);
                    }
                ]
            },
            abstract: true
            })
            .state('app.racedays.raceday.edit', {
                url: '/edit',
                views: {
                    'primary@app': {
                               component: 'racedayEditPage'
                    }
                }
            })
            .state('app.racedays.raceday.event', {
                url: '/event',
                abstract: true,
                resolve: {
                    raceday: ['$stateParams', 'RacedaysService',
                        function($stateParams, RacedaysService) {
                            return RacedaysService.getById($stateParams.id);
                        }
                    ],
                    locations: ['$stateParams', 'LocationService',
                        function($stateParams, LocationService) {
                            return LocationService.getAll();
                        }
                    ]
                }
            })
            .state('app.racedays.raceday.event.add', {
                url: '/add',
                views: {
                    'primary@app': {
                        component: 'eventAddPage'
                    }
                }
            })
            .state('app.racedays.raceday.event.edit', {
                url: '/:eventId/edit',
                views: {
                    'primary@app': {
                        component: 'eventEditPage'
                    }
                },
                resolve: {
                    event: ['EventService', '$stateParams',
                        function (EventService, $stateParams) {
                            var eventId = $stateParams.eventId;
                            var racedayId = $stateParams.id;
                            return EventService.getById(eventId, racedayId);
                        }
                    ],
                    locations: ['LocationService',
                        function (LocationService) {
                            return LocationService.getAll();
                        }
                    ],
                    raceday: ['RacedaysService', '$stateParams',
                        function (RacedaysService, $stateParams) {
                            var racedayId = $stateParams.id;
                            return RacedaysService.getById(racedayId);
                        }
                    ]
                }
            })
            .state('app.advertising', {
              url: '/advertising',
              data: {
                  roles: ['ROLE_USER']
              },
              abstract: true
          })
            .state('app.advertising.feature', {
                url: '/feature',
                views: {
                    'primary@app': {
                        component: 'advertFeaturePage'
                    }
                }
            })
            .state('app.advertising.inline', {
                url: '/inline',
                views: {
                    'primary@app': {
                        component: 'advertInlinePage'
                    }
                }
            })
            .state('app.advertising.experience', {
                url: '/experience',
                views: {
                    'primary@app': {
                        component: 'advertExperiencePage'
                    }
                }
            })
            .state('app.advertising.featureadd', {
                url: '/feature/add',
                views: {
                    'primary@app': {
                        component: 'advertAddPage'
                    }
                },
                resolve: {
                    linkTypes: ['LinkTypeService',
                        function(LinkTypeService) {
                            return LinkTypeService.getAll();
                        }
                    ],
                    racedays: ['RacedaysService',
                        function(RacedaysService) {
                            return RacedaysService.getAll();
                        }
                    ],
                    advert: ['AdvertService','$stateParams',
                        function(AdvertService, $stateParams) {
                            return AdvertService.getById($stateParams.advertId);
                        }
                    ],
                    locations: ['$stateParams', 'LocationService',
                        function($stateParams, LocationService) {
                            return LocationService.getAll();
                        }
                    ],
                    nonRacingEvents: ['$stateParams', 'EventService',
                        function($stateParams, EventService) {
                            return EventService.getAllNonRacingEvents();
                        }
                    ]
                },
                params: {
                    advertType: 1,
                    returnSuccessState : 'app.advertising.feature'
                }
            })
            .state('app.advertising.featureedit', {
                url: '/feature/edit/:advertId',
                views: {
                    'primary@app': {
                        component: 'advertEditPage'
                    }
                },
                resolve: {
                    linkTypes: ['LinkTypeService',
                        function(LinkTypeService) {
                            return LinkTypeService.getAll();
                        }
                    ],
                    racedays: ['RacedaysService',
                        function(RacedaysService) {
                            return RacedaysService.getAll();
                        }
                    ],
                    advert: ['AdvertService','$stateParams',
                        function(AdvertService, $stateParams) {
                            return AdvertService.getById($stateParams.advertId);
                        }
                    ],
                    locations: ['$stateParams', 'LocationService',
                        function($stateParams, LocationService) {
                            return LocationService.getAll();
                        }
                    ],
                    nonRacingEvents: ['$stateParams', 'EventService',
                        function($stateParams, EventService) {
                            return EventService.getAllNonRacingEvents();
                        }
                    ]
                },
                params: {
                    advertType: 1,
                    returnSuccessState : 'app.advertising.feature'
                }
            })
            .state('app.advertising.inlineadd', {
                url: '/inline/add',
                views: {
                    'primary@app': {
                        component: 'advertAddPage'
                    }
                },
                resolve: {
                    linkTypes: ['LinkTypeService',
                        function(LinkTypeService) {
                            return LinkTypeService.getAll();
                        }
                    ],
                    racedays: ['RacedaysService',
                        function(RacedaysService) {
                            return RacedaysService.getAll();
                        }
                    ],
                    advert: ['AdvertService','$stateParams',
                        function(AdvertService, $stateParams) {
                            return AdvertService.getById($stateParams.advertId);
                        }
                    ],
                    socialMediaCategories: ['SocialCategoryService',
                        function(SocialCategoryService) {
                            return SocialCategoryService.getCategories();
                        }
                    ],
                    locations: ['$stateParams', 'LocationService',
                        function($stateParams, LocationService) {
                            return LocationService.getAll();
                        }
                    ],
                    nonRacingEvents: ['$stateParams', 'EventService',
                        function($stateParams, EventService) {
                            return EventService.getAllNonRacingEvents();
                        }
                    ]
                },
                params: {
                    advertType: 2,
                    returnSuccessState : 'app.advertising.inline'
                }
            })
            .state('app.advertising.inlineedit', {
                url: '/inline/edit/:advertId',
                views: {
                    'primary@app': {
                        component: 'advertEditPage'
                    }
                },
                resolve: {
                    linkTypes: ['LinkTypeService',
                        function(LinkTypeService) {
                            return LinkTypeService.getAll();
                        }
                    ],
                    racedays: ['RacedaysService',
                        function(RacedaysService) {
                            return RacedaysService.getAll();
                        }
                    ],
                    advert: ['AdvertService','$stateParams',
                        function(AdvertService, $stateParams) {
                            return AdvertService.getById($stateParams.advertId);
                        }
                    ],
                    socialMediaCategories: ['SocialCategoryService',
                        function(SocialCategoryService) {
                            return SocialCategoryService.getCategories();
                        }
                    ],
                    locations: ['$stateParams', 'LocationService',
                        function($stateParams, LocationService) {
                            return LocationService.getAll();
                        }
                    ],
                    nonRacingEvents: ['$stateParams', 'EventService',
                        function($stateParams, EventService) {
                            return EventService.getAllNonRacingEvents();
                        }
                    ]
                },
                params: {
                    advertType: 2,
                    returnSuccessState : 'app.advertising.inline'
                }
            })
            .state('app.advertising.experienceadd', {
                url: '/experience/add',
                views: {
                    'primary@app': {
                        component: 'advertAddPage'
                    }
                },
                resolve: {
                    linkTypes: ['LinkTypeService',
                        function(LinkTypeService) {
                            return LinkTypeService.getAll();
                        }
                    ],
                    racedays: ['RacedaysService',
                        function(RacedaysService) {
                            return RacedaysService.getAll();
                        }
                    ],
                    advert: ['AdvertService','$stateParams',
                        function(AdvertService, $stateParams) {
                            return AdvertService.getById($stateParams.advertId);
                        }
                    ],
                    socialMediaCategories: ['SocialCategoryService',
                        function(SocialCategoryService) {
                            return SocialCategoryService.getCategories();
                        }
                    ],
                    locations: ['$stateParams', 'LocationService',
                        function($stateParams, LocationService) {
                            return LocationService.getAll();
                        }
                    ],
                    nonRacingEvents: ['$stateParams', 'EventService',
                        function($stateParams, EventService) {
                            return EventService.getAllNonRacingEvents();
                        }
                    ]
                },
                params: {
                    advertType: 3,
                    returnSuccessState : 'app.advertising.experience'
                }
            })
            .state('app.advertising.experienceedit', {
                url: '/experience/edit/:advertId',
                views: {
                    'primary@app': {
                        component: 'advertEditPage'
                    }
                },
                resolve: {
                    linkTypes: ['LinkTypeService',
                        function(LinkTypeService) {
                            return LinkTypeService.getAll();
                        }
                    ],
                    racedays: ['RacedaysService',
                        function(RacedaysService) {
                            return RacedaysService.getAll();
                        }
                    ],
                    advert: ['AdvertService','$stateParams',
                        function(AdvertService, $stateParams) {
                            return AdvertService.getById($stateParams.advertId);
                        }
                    ],
                    socialMediaCategories: ['SocialCategoryService',
                        function(SocialCategoryService) {
                            return SocialCategoryService.getCategories();
                        }
                    ],
                    locations: ['$stateParams', 'LocationService',
                        function($stateParams, LocationService) {
                            return LocationService.getAll();
                        }
                    ],
                    nonRacingEvents: ['$stateParams', 'EventService',
                        function($stateParams, EventService) {
                            return EventService.getAllNonRacingEvents();
                        }
                    ]
                },
                params: {
                    advertType: 3,
                    returnSuccessState : 'app.advertising.experience'
                }
            })
            .state('app.map', {
                url: '/map',
                data: {
                    roles: ['ROLE_USER']
                },
                abstract: true
            })
          .state('app.map.locations', {
              url: '/locations',
              data: {
                  roles: ['ROLE_USER']
              },
              views: {
                  'primary@app': {
                      component: 'mapLocationPage'
                  }
              },
              resolve: {
                  filters: ['FiltersService',
                      function (FiltersService) {
                          return FiltersService.getAll();
                      }
                  ],
                  locations: ['LocationService',
                     function (LocationService) {
                         return LocationService.getAll();
                     }
                  ]
              }
          })
            .state('app.map.locations.add', {
                url: '/add',
                data: {
                    roles: ['ROLE_USER']
                },
                views: {
                    'primary@app': {
                        component: 'mapLocationAddPage'
                    }
                },
                resolve: {
                    locationTypes: ['LocationTypeService',
                        function (LocationTypeService) {
                            return LocationTypeService.getAll();
                        }
                    ],
                    accesses: ['LocationAccessService',
                        function (LocationAccessService) {
                            return LocationAccessService.getAll();
                        }
                    ],
                    locationFilters: ['FiltersService',
                        function (FiltersService) {
                            return FiltersService.getAll();
                        }
                    ]
                }
            })
            .state('app.map.locations.edit', {
                url: '/edit/:locationId',
                data: {
                    roles: ['ROLE_USER']
                },
                views: {
                    'primary@app': {
                        component: 'mapLocationEditPage'
                    }
                }
            })
            .state('app.map.filters', {
                url: '/filters',
                data: {
                    roles: ['ROLE_USER']
                },
                views: {
                    'primary@app': {
                        component: 'mapFilterPage'
                    }
                }
            })
            .state('app.map.filters.add', {
                url: '/add',
                data: {
                    roles: ['ROLE_USER']
                },
                views: {
                    'primary@app': {
                        component: 'mapFilterAddPage'
                    }
                }
            })
            .state('app.map.filters.edit', {
                url: '/edit/:filterId',
                data: {
                    roles: ['ROLE_USER']
                },
                views: {
                    'primary@app': {
                        component: 'mapFilterEditPage'
                    }
                }
            })
          /* flagged for removal with task VRCSTORE-1037
          .state('app.pushMessages', {
              url: '/push-messages',
              data: {
                  roles: ['ROLE_USER']
              },
              views: {
                  'primary@app': {
                      component: 'pushMessagesPage'
                  }
              }
          })
          */
          .state('app.social', {
              url: '/social',
              data: {
                  roles: ['ROLE_USER']
              },
              views: {
                  'primary@app': {
                      component: 'socialPage'
                  }
              }
          })
          .state('app.moreItems', {
            url: '/more-items',
            data: {
              roles: ['ROLE_USER']
            },
            abstract: true
          })
          .state('app.moreItems.dynamicLinks', {
            url: '/dynamic-links',
            data: {
              roles: ['ROLE_USER']
            },
            views: {
              'primary@app': {
                component: 'dynamicLinkListPage'
              }
            }
          })
          .state('app.moreItems.dynamicLinks.add', {
            url: '/add',
            data: {
              roles: ['ROLE_USER']
            },
            views: {
              'primary@app': {
                component: 'dynamicLinkAddPage'
              }
            },
            params: {
              returnSuccessState: 'app.moreItems.dynamicLinks'
            }
          })
          .state('app.moreItems.dynamicLinks.edit', {
            url: '/edit/:id',
            data: {
              roles: ['ROLE_USER']
            },
            views: {
              'primary@app': {
                component: 'dynamicLinkEditPage'
              }
            },
            params: {
              returnSuccessState: 'app.moreItems.dynamicLinks'
            },
            resolve: {
              dynamicLink: ['$stateParams', 'DynamicLinkService',
                function ($stateParams, DynamicLinkService) {
                  return DynamicLinkService.getById($stateParams.id);
                }
              ]
            },
          })
					.state('app.profile', {
              url: '/profile',
              data: {
                  roles: ['ROLE_USER']
              },
              views: {
                  'primary@app': {
                      component: 'profilePage'
                  }
              }
          })

  }]).config(['$provide',function($provide) {
    "ngInject";
    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions) {
        taOptions.forceTextAngularSanitize = false;
        return taOptions;
    }]);
  }])
  .component('app', AppComponent);
